import { ResourceAdministration } from '@/features/resources';
import { useObjectDetail } from './ObjectDetailContext';

export function ObjectResourcesTab() {
  const { groupId, canEdit } = useObjectDetail();
  return (
    <section aria-labelledby="object-resources-title" className="space-y-5">
      <div>
        <h2 id="object-resources-title" className="text-ink font-serif text-2xl">
          Ressourcen
        </h2>
        <p className="text-ink-soft mt-1 max-w-3xl text-sm">
          Räume, die Gäste mit einer gültigen Buchung stundenweise und exklusiv reservieren – etwa
          ein Seminar- oder Gemeinschaftsraum. Ohne aktive Ressource ändert sich im Gastportal
          nichts.
        </p>
      </div>
      <ResourceAdministration groupId={groupId} canEdit={canEdit} />
    </section>
  );
}
